import AbstractService from "./AbstractService";
import Axios from "axios";

export default class ProfileService extends AbstractService {
    private controller = "profile";

    public get(q: any = null) {
        const url = this.makeUrlWithQueries(`${this.controller}`, q);
        return Axios.get<any>(url, this.makeConfig(false));
    }

    public walletBalance() {
        const url = this.makeUrl(`${this.controller}/wallet-balance`);
        return Axios.get<any>(url, this.makeConfig(false));
    }

    public put(user: any, updatePassword: boolean, password: string, confirmPassword: string) {
        const d = { user, updatePassword, password, confirmPassword };
        const url = this.makeUrl(`${this.controller}`);
        return Axios.put<any>(url, d, this.makeConfig());
    }

    public changePassword(user: any, currentPassword: string, newPassword: string, confirmPassword: string) {
        const d = { user, currentPassword, newPassword, confirmPassword };
        const url = this.makeUrl(`${this.controller}/change-password`);
        return Axios.put<any>(url, d, this.makeConfig());
    }

    public closeAccount() {
        const url = this.makeUrl(`${this.controller}/close-account`);
        return Axios.delete<any>(url, this.makeConfig());
    }
}